<template>
<div class="c-step step-3">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Czy miejsce to jest ogólnodostępne?
    </div>
  </div>
  <div class="c-step-answers">
    <button v-on:click="answer('Tak')">Tak</button>
    <button v-on:click="answer('Nie','3-1')">Nie</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step3',
  components: {
    'stepsCounter': stepsCounter
  },
  methods: {
    answer(answer, substep = null) {
      if (substep) {
        this.$store.dispatch('answer', {
          step: '3',
          answer: answer,
          substep: substep
        })
      } else {
        this.$store.dispatch('answer', {
          step: '3',
          answer: answer
        })
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
